import { supabase } from './supabase.js';
import { TRANSACTION_LOGISTICS_NESTED } from '../marketplace/constants/transactionLogistics.js';

const CUSTODY_LISTING_SELECT = `
  id,
  listing_id,
  transaction_id,
  buyer_profile_id,
  status,
  partner_notes,
  delivery_pin,
  partner_outbound_tracking,
  partner_outbound_shipped_at,
  created_at,
  updated_at,
  transaction:transactions (
    ${TRANSACTION_LOGISTICS_NESTED}
  ),
  listing:listings (
    id,
    title,
    artist,
    seller_id,
    ships_verified,
    status,
    cover_url,
    photos,
    is_auction,
    auction_partner_id,
    profiles ( username )
  )
`;

/**
 * @param {string} partnerId
 * @returns {Promise<{ data: object[], error: string|null }>}
 */
export async function fetchPartnerStoreCustody(partnerId) {
  if (!partnerId) return { data: [], error: 'missing_partner' };
  const { data, error } = await supabase
    .from('partner_store_custody')
    .select(CUSTODY_LISTING_SELECT)
    .eq('partner_id', partnerId)
    .order('updated_at', { ascending: false })
    .limit(200);
  if (error) {
    console.error('[partnerCustodyService] fetch:', error.message);
    return { data: [], error: error.message };
  }
  return { data: data ?? [], error: null };
}

/**
 * @param {string} listingId
 * @returns {Promise<{ row: object|null, error: string|null }>}
 */
export async function fetchListingRowForCustodyPreview(listingId) {
  if (!listingId) return { row: null, error: 'missing_listing' };
  const { data, error } = await supabase
    .from('listings')
    .select('id, title, artist, seller_id, ships_verified, status, cover_url, photos, is_auction, auction_partner_id')
    .eq('id', listingId)
    .maybeSingle();
  if (error) {
    console.error('[partnerCustodyService] listing preview:', error.message);
    return { row: null, error: error.message };
  }
  return { row: data ?? null, error: null };
}

/**
 * @param {{ partnerId: string, listingId: string, transactionId?: string|null }} p
 */
export async function insertPartnerStoreCustody(p) {
  if (!p?.partnerId || !p?.listingId) return { error: 'Parámetros incompletos' };
  const { error } = await supabase.from('partner_store_custody').insert({
    partner_id: p.partnerId,
    listing_id: p.listingId,
    transaction_id: p.transactionId ?? null,
    status: 'esperando',
  });
  if (error) {
    console.error('[partnerCustodyService] insert:', error.message);
    return { error: error.message };
  }
  return { error: null };
}

/**
 * @param {{ id: string, partnerId: string, nextStatus: string, partnerNotes?: string|null, buyerProfileId?: string|null, deliveryPin?: string|null }} p
 */
export async function updatePartnerStoreCustodyRow(p) {
  if (!p?.id || !p?.partnerId || !p?.nextStatus) return { error: 'Parámetros incompletos' };
  const payload = { status: p.nextStatus };
  if (p.partnerNotes !== undefined) {
    const t = String(p.partnerNotes).trim();
    payload.partner_notes = t || null;
  }
  if (p.buyerProfileId !== undefined) {
    const u = String(p.buyerProfileId).trim();
    payload.buyer_profile_id = /^[0-9a-f-]{36}$/i.test(u) ? u : null;
  }
  if (p.deliveryPin !== undefined) {
    const d = String(p.deliveryPin).trim();
    payload.delivery_pin = d ? d.slice(0, 32) : null;
  }
  const { error } = await supabase.from('partner_store_custody').update(payload).eq('id', p.id).eq('partner_id', p.partnerId);
  if (error) {
    console.error('[partnerCustodyService] update:', error.message);
    return { error: error.message };
  }
  return { error: null };
}
